import { render, staticRenderFns } from "./model_tags.vue?vue&type=template&id=08fb3da2&"
import script from "./model_tags.vue?vue&type=script&lang=js&"
export * from "./model_tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08fb3da2')) {
      api.createRecord('08fb3da2', component.options)
    } else {
      api.reload('08fb3da2', component.options)
    }
    module.hot.accept("./model_tags.vue?vue&type=template&id=08fb3da2&", function () {
      api.rerender('08fb3da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/model_tags.vue"
export default component.exports